import React, { FC, ReactElement, MouseEvent } from 'react'
import { NETWORK } from '@/utils/constants'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const BitcoinIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="-4 -4 40 40"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			{/* Standard Bitcoin mark (cryptocurrency-icons, CC0). Circle fills 80% of the box. */}
			<circle cx="16" cy="16" r="16" fill="#F7931A" />
			<path fillRule="nonzero" fill="#FFFFFF" d="M23.189 14.02c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 6l-.708 2.839c-.376-.086-.746-.17-1.104-.26l.002-.009-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235c.048.012.11.03.18.057l-.183-.045-1.13 4.532c-.086.212-.303.531-.793.41.018.025-1.256-.313-1.256-.313l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.715 2.872 1.727.43.708-2.84c.472.127.93.245 1.378.357l-.706 2.828 1.728.43.715-2.866c2.948.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11zm.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733z" />
		</svg>
	)
}

const DogecoinIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<g clipPath="url(#clip0_5037_13761)">
				<rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
				<path
					d="M12.24 8.59H10.81V11.41H13.06V12.59H10.81V15.4H12.31C12.7 15.4 15.47 15.45 15.47 12.13C15.46 8.8 12.77 8.59 12.24 8.59Z"
					fill="#C2A633"
				/>
				<path
					d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.39 17.4H8.77V12.59H7.49V11.41H8.77V6.59H11.88C12.61 6.59 17.49 6.44 17.49 12.09C17.49 17.83 12.39 17.4 12.39 17.4H12.39Z"
					fill="#C2A633"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5037_13761">
					<rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}

const BellsIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M8.52 21.89C0.6 19.82 4.37 9.94 10.07 8.45C10.2 7.44 10.56 7.17 10.72 7.16C10.54 6.53 10.31 5.03 10.84 3.99C11.5 2.7 12.49 1.78 14.59 2.04C16.26 2.25 16.72 3.65 16.74 4.31C17.32 4.41 17.7 4.7 17.81 4.84C19.92 7.55 17.23 8.7 15.89 8.7L15.84 8.98C17.5 9.41 18.94 11.34 19.45 12.25L19.09 12.6C21.69 17.47 18.71 20.75 15.84 21.71V22.11L8.52 22.3V21.89Z"
				fill="#EAB148"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.59 3.46C16.73 3.78 16.78 4.09 16.79 4.31C17.37 4.41 17.75 4.7 17.86 4.84C19.97 7.54 17.28 8.7 15.95 8.7L15.93 8.77L11.52 7.36C11.91 6.38 13.96 7.35 14.94 7.96C15.5 6.97 16.47 6.67 16.88 6.64C16.77 5.52 16.31 5.53 16.03 5.53C16.01 5.53 15.98 5.53 15.96 5.53C15.75 5.52 15.08 5.88 14.77 6.06C15.12 4.2 16.03 3.58 16.59 3.46Z"
				fill="#E68F2F"
			/>
			<path
				d="M9.49 17.18L7.72 17.9C7.43 18.02 7.11 17.77 7.17 17.46L7.57 15.28C7.59 15.18 7.57 15.08 7.51 14.99L6.62 13.57C6.47 13.32 6.62 13 6.91 12.95L8.95 12.66C9.03 12.65 9.11 12.61 9.18 12.55L10.8 10.94C11.02 10.72 11.38 10.81 11.47 11.09L12.01 12.71C12.05 12.83 12.15 12.92 12.27 12.96L14.34 13.63C14.65 13.73 14.72 14.14 14.46 14.34L12.6 15.79C12.5 15.87 12.44 15.98 12.44 16.11V17.98C12.44 18.29 12.11 18.48 11.84 18.33L9.84 17.21C9.73 17.15 9.61 17.14 9.49 17.18Z"
				fill="#3D1510"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.1 17.71C4.47 19.58 5.82 21.18 8.51 21.89V22.3L15.83 22.11V21.71C18.7 20.75 21.68 17.47 19.08 12.6L19.44 12.25C18.99 11.46 17.86 9.91 16.49 9.23L15.07 9.57C18.88 15.33 15.84 17.74 15.09 18.34L15.07 18.35C14.34 18.93 12.91 19.76 9.64 19.9C7.3 20.01 5.15 18.63 4.1 17.71Z"
				fill="#E48D2B"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.88 8.82L15.85 8.98C17.5 9.4 18.94 11.33 19.45 12.25L19.3 12.4L18.29 12.97C18.09 12.61 17.3 11.57 16.93 11.1C17.13 11.53 17.45 12.82 17.58 13.42L16.37 13.76C16.36 13.65 16.31 13.44 16.24 13.42L15.29 9.1C15.46 8.92 15.66 8.83 15.88 8.82Z"
				fill="#DD6C20"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.97 10.38C18.48 10.89 18.9 11.45 19.19 11.89C19.23 11.97 19.27 12.04 19.3 12.12L18.31 12.77C17.75 11.94 16.5 10.25 16.01 10.14C16.28 10.49 16.87 11.59 17.07 13.22L15.81 13.56C15.58 12.47 15.01 10.17 14.58 9.77C14.21 9.44 14.03 9.4 12.86 9.13C12.25 8.98 11.38 8.78 10.08 8.44C10.08 8.36 10.09 8.26 10.1 8.15C10.23 7.52 10.46 7.27 10.61 7.2L14.51 8.19C14.63 8.14 15 8.1 15.53 8.31C15.57 8.33 15.64 8.42 15.62 8.63L15.86 8.75L15.82 9C15.86 9.02 15.9 9.03 15.94 9.04C16.46 9.27 17.25 9.73 17.97 10.38Z"
				fill="#C50A0C"
			/>
		</svg>
	)
}

const SignetIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 45 44"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M40.06 26.35C37.65 36 27.89 41.87 18.24 39.46C8.6 37.06 2.73 27.29 5.14 17.65C7.54 8 17.31 2.13 26.95 4.54C36.59 6.94 42.46 16.71 40.06 26.35Z"
				fill="rgb(176, 40, 170)"
			/>
			<path
				d="M30.53 19.44C30.89 17.04 29.07 15.75 26.58 14.89L27.38 11.65L25.41 11.16L24.62 14.32C24.1 14.19 23.57 14.06 23.04 13.94L23.83 10.76L21.86 10.27L21.05 13.52C20.62 13.42 20.2 13.32 19.79 13.22L19.79 13.21L17.07 12.53L16.54 14.64C16.54 14.64 18.01 14.97 17.98 14.99C18.78 15.19 18.92 15.72 18.9 16.14L17.97 19.84C18.03 19.85 18.1 19.87 18.18 19.91C18.11 19.89 18.04 19.87 17.97 19.85L16.68 25.03C16.58 25.27 16.33 25.64 15.77 25.5C15.79 25.53 14.34 25.14 14.34 25.14L13.36 27.4L15.93 28.04C16.41 28.16 16.88 28.29 17.34 28.41L16.52 31.69L18.49 32.18L19.3 28.93C19.84 29.08 20.36 29.22 20.88 29.34L20.07 32.57L22.04 33.07L22.86 29.79C26.23 30.43 28.76 30.17 29.83 27.12C30.69 24.67 29.78 23.26 28.01 22.34C29.3 22.04 30.27 21.19 30.53 19.44ZM26.02 25.76C25.41 28.22 21.28 26.89 19.94 26.56L21.03 22.21C22.37 22.54 26.66 23.21 26.02 25.76ZM26.63 19.4C26.08 21.63 22.64 20.5 21.52 20.22L22.51 16.28C23.62 16.55 27.21 17.07 26.63 19.4Z"
				fill="white"
			/>
		</svg>
	)
}

const Icon =
	{
		DOGE: DogecoinIcon,
		BELLS: BellsIcon,
		BTC: BitcoinIcon,
		SIGNET: SignetIcon
	}[NETWORK] || BitcoinIcon

export default Icon
